import { Component, OnInit, ViewChild } from '@angular/core';

import { SponserService } from '../../Services/sponser.service';

import { ISponserData, ITblSponser, ITbl_Products, ITbl_SponserContacts, SponsorProduct } from '../../Models/sponser-data'
import { Router } from '@angular/router';
import { CodeListValues } from '../../Models/country-data';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { ActiveInActiveStatus, Dateformat, breadcrumnsCodes, AuditIdentifier, AuditLogEntities, AuditOperations, AuditLogModule, FileExtension } from 'src/app/shared/constants/global.constants';
import { LoaderService } from 'src/app/Loader/loader.service';
import { IDeactivateGuard } from 'src/app/shared/Guards/can-deactivate-guard.service';

import { ActivatedRoute } from '@angular/router';
import { BreadcrumbService } from 'src/app/shared/Breadcrumb/breadcrumb.service';
import { AuditLogService } from '../../../shared/ModelComparison/audit.log.service';
import { ContractService } from '../../../Contracts/Services/contract.service';
import { AuditLogModel } from '../../../shared/ModelComparison/audit.log.response.model';
import { PrivilegeService } from 'src/app/Reusable/privilege.service';
import { MasterSupplierService } from '../../supplier/Services/master.supplier.service';
import { EngagementService } from 'src/app/Engagement/Services/engagement.service';
import { SuppliersMasterServiceAgreement } from '../../Services/supplier-profile';
import { Privileges } from 'src/app/shared/constants/privileges.constants';
import FileSaver from 'file-saver';
import { DatePipe } from '@angular/common';
import { ProductFilterDetails } from '../../Models/getSponserFilter';

@Component({
  selector: 'app-editsponser',
  templateUrl: './editsponser.component.html',
  styleUrls: ['./editsponser.component.css']
})
export class EditsponserComponent implements OnInit, IDeactivateGuard {
  unsavedChanges: boolean = false;
  displayDialog: boolean = false;
  cardData: any;
  myForm: FormGroup;
  dialogFormGroup: FormGroup;
  localConatctId: number = 0;
  localProductId:number=0;
  editContactFlag = false;
  sponserData: ISponserData = {};
  sponserInfo: ITblSponser = {};
  sponserContact: ITbl_SponserContacts = {};
  sponserContactList: ITbl_SponserContacts[] = [];
  countryCodes: CodeListValues[] | undefined;
  CreatedbyUserName: string = '';
  oldSponserData: string = "";
  oldSponserContactData: string = "";
  sponsorDetailBeforeUpdate: any;
  sponsorContactDetailListBeforeUpdate: any;
  blankSponsorContact: ITbl_SponserContacts = {};

  submitted = false;
  isSaveBtnDisable = false;
  contactSubmitted = false;
  isDisabled: boolean = true;
  public weightConfirmed: boolean = false;
  sponserIdToUpdate: number = 0;
  updatedSponserContactList: ITbl_SponserContacts[] = [];
  _dateformart: any;
  executeCanExist: boolean = true;
  _enumBreadcrumb: any;
  changedSponsorProperties: any[] = [];
  changedSponsorContactsProperties: any[] = [];
  selectedOption: string = "";
  selectedsponserstatus: any[] = [];
  filterselectedsponserstatus: any[] = [];
  statusData: any[] = [];
  noOfSuppliersAreLinkedwithSponserId: any;
  defaultactivestatus: any[] = [];
  defaultselectedactivestatus: any[] = [];
  statusInactive: boolean = false;

  status: boolean = false;
  statusValue: string = "";
  supplierStatusData: any[] = [];
  contractStatusData: any[] = [];
  defaultSupplierActiveStatus: any[] = [];
  supplierActiveStatus: any[] = [];
  supplierStatusMappingId: any;
  defaultContractActiveStatus: any[] = [];
  contractActiveStatus: any[] = [];
  contractStatusMappingId: any;
  sponserStatusMappingId: any;
  sponserStatusMappingValue: any[] = [];
  auditIdentifierDetails: any;
  contactHeader = 'Add Contact';
  uniqueSponsorContactNameMessage = false;
  uniqueSponsorNameMessage = false;
  allSponsordetails: any[] = [];
  newProducts: any[]=[];

  totalRecordCount: number = 0;
  filteredRecordCount: number = -1;
  productFormGroup: FormGroup;
  editPrivilege: boolean = false;
  ExportPrivilege: boolean = false;
  productList: ITbl_Products[] = [];
  products: ITbl_Products = {};
  @ViewChild('dt') table: any;

  constructor(private _service: SponserService, private router: Router,
    private _SupplierSerice: MasterSupplierService,
    private _contractService: ContractService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private loaderService: LoaderService, private breadcrumbService: BreadcrumbService,
    private auditLogService: AuditLogService,
    private privilegeService: PrivilegeService, private datePipe: DatePipe,
    private engagementService: EngagementService, private activeRouter: ActivatedRoute) {

    this.myForm = this.fb.group({
      sponserName: ['', [Validators.required, Validators.maxLength(100), Validators.minLength(3), Validators.pattern(/^(?=(?:[^a-zA-Z]*[a-zA-Z]){3})/), this.notOnlySpacesValidator]],
      sponserAddress: ['', [Validators.maxLength(300)]],
      sponserId: [''],
      sponserNotesAndComments: ['', [Validators.maxLength(300)]],
    });

    this.dialogFormGroup = this.fb.group({
      contactName: ['', [Validators.required, Validators.maxLength(30), Validators.pattern(/^[a-zA-Z\s]{1,30}$/), this.notOnlySpacesValidator]],
      contactDesignation: ['', [Validators.maxLength(100), Validators.minLength(3), this.notOnlySpacesValidator]],
      countryCode: [''],
      phoneNumber: ['', [Validators.minLength(7), Validators.maxLength(15)]],
      email: ['', [Validators.required, Validators.maxLength(100)]]
    });

    this.productFormGroup = this.fb.group({
      productName: ['', [Validators.required, Validators.maxLength(200), this.notOnlySpacesValidator]],
      longName: ['', [ Validators.maxLength(200), this.notOnlySpacesValidator]],
      genericName: ['', [ Validators.maxLength(200), this.notOnlySpacesValidator]],
      internalName: ['', [ Validators.maxLength(200), this.notOnlySpacesValidator]],
      tradeName: ['', [ Validators.maxLength(200), this.notOnlySpacesValidator]],
      productStatus: ['', [Validators.required]],
    });

    this.isDisabled = true;

  }

  validateOnlyNumberandSpecialCharecters(control: AbstractControl): ValidationErrors | null {
    const alphaRegex = /[a-zA-Z]/; // Ensure at least one alphabetic character
    if (control.value && !alphaRegex.test(control.value)) {
      return { invalidNumberSpecialCharecters: true };
    }
    return null;
  }

  validateAlphaCharacters(control: AbstractControl): ValidationErrors | null {
    const value = control.value;


    const pattern = /^[a-zA-Z\s]*$/;

    if (value && !pattern.test(value)) {
      return { invalidAlphaCharacters: true };
    }

    return null;
  }

  notOnlySpacesValidator(control: AbstractControl): { [key: string]: boolean } | null {
    if (control.value && control.value.trim() === '') {
      return { 'onlySpaces': true };
    }
    return null;
  }
  auditEntities: any;
  auditOperations: any;
  auditModule: any;

  ngOnInit(): void {
    this._enumBreadcrumb = breadcrumnsCodes;
    this.generateBreadcrumb(this._enumBreadcrumb.EVSP);
    this._dateformart = Dateformat;
    this.auditIdentifierDetails = AuditIdentifier;
    this.auditEntities = AuditLogEntities;
    this.auditOperations = AuditOperations;
    this.auditModule = AuditLogModule;


    this.GetsponserStatus();
    this.BindPrivileges();
    localStorage.setItem('LoggedInUserName', 'TestUser');
    this.route.params.subscribe(params => {

      this.sponserIdToUpdate = +params['id'] //log the value of id
    });

    this._service.getCodeListData(0, '').subscribe(
      data => {
        this.countryCodes = data.data;

      }
    );
    this.getAllEngagementsBySponsorId();

    this.loaderService.showLoader();

    //     this._service.getSponserData(this.sponserIdToUpdate).subscribe(
    //       res=>{
    //         this.loaderService.hideLoader();
    //         this.sponserInfo.name=res.data.sponserInfo?.name;

    //         this.sponserInfo.address=res.data.sponserInfo?.address;
    //         this.sponserInfo.notesAndComments=res.data.sponserInfo?.notesAndComments;
    //         this.sponserInfo.id=res.data.sponserInfo?.id;
    //         this.sponserInfo.sponserId=res.data.sponserInfo?.sponserId;
    //         this.CreatedbyUserName=this.privilegeService.getUserName(res.data.sponserInfo?.createdBy); 
    //         this.sponserInfo.createdDate=res.data.sponserInfo?.createdDate;

    //           this.allProducts = res.data.products;
    //        this.productList = [...this.allProducts];

    //       const statusMap = new Map<number, string>();
    //       this.statusData.forEach((status: { id: number; name: string; }) => {
    //       statusMap.set(status.id, status.name);
    //       });

    //       this.productList.forEach((product: any) => {
    //       const statusId = Number(product.statusMappingId);
    //       product.status = statusMap.get(statusId) || 'Unknown';
    //       product.createdBy= this.privilegeService.getUserName(product.createdBy);
    //       product.updatedBy=this.privilegeService.getUserName(product.updatedBy);
    // });

    //        this. totalRecordCount=this.productList.length;
    //        this.filteredRecordCount=this.productList.length;

    //         this.sponserContactList=res.data.sponserContacts;
    //         this.generateBreadcrumb(this._enumBreadcrumb.EVSP,this.sponserInfo.name);



    //         this.oldSponserData=JSON.stringify(this.sponserInfo);


    //         this.sponsorDetailBeforeUpdate=JSON.stringify(this.sponserInfo);
    //         this.sponsorContactDetailListBeforeUpdate=JSON.stringify(this.sponserContactList);

    //         this.GetsponserStatus();
    //         this.sponserContactList.forEach(item => {
    //           item.localId=this.localConatctId;
    //           this.localConatctId=this.localConatctId+1;
    //           this.updatedSponserContactList.push(item);
    //         });


    //         this.sponserContactList=this.updatedSponserContactList;
    //         this.oldSponserContactData=JSON.stringify(this.sponserContactList);



    //       });
    // this.getSponserData();
    this.GetSupplierStatus();
    this.GetContractStatus();
    this.loaderService.hidefinalLoader();// hide after 4 seconds even get any error  
    this.GetAllSponsors();
  }
  GetSuppliercount() {
    this._SupplierSerice.GetSuppliersLinkedwithSponserId(this.sponserInfo.id)
      .subscribe(res => {
        this.noOfSuppliersAreLinkedwithSponserId = res.data;
      });
  }
  updateSponserData() {
    this.ClearFilters();
    this.GetSuppliercount();
    this.submitted = true;
    this.isSaveBtnDisable = true;
    setTimeout(() => {
      this.isSaveBtnDisable = false;
    }, 3000);

    if (this.myForm.valid && !this.uniqueSponsorNameMessage) {
      this.executeCanExist = false;
      this.sponserInfo.updatedBy = this.privilegeService.getLoginUserId();
      this.sponserInfo.updatedDate = new Date();
      if (this.sponserInfo.address == undefined) {
        this.sponserInfo.address = "";
      }
      if (this.sponserInfo.notesAndComments == undefined) {
        this.sponserInfo.notesAndComments = "";
      }
      this.sponserData["sponserInfo"] = this.sponserInfo;
      this.sponserData["sponserContacts"] = this.sponserContactList;
      const cleanedProducts = (this.newProducts || []).map((p: {id:any, productName: any; longName: any; genericName: any; internalName: any; tradeName: any; statusMappingId: any; isDeleted: any; }) => ({
            id: p.id || 0,
            productName: p.productName || null,
            longName: p.longName || null,
            genericName: p.genericName || null,
            internalName: p.internalName || null,
            tradeName: p.tradeName || null,
            statusMappingId: p.statusMappingId || null,
            isDeleted: p.isDeleted ?? false
          }));

      this.sponserData["Products"] = cleanedProducts;

  
      this._service.updateSponserData(this.sponserData.sponserInfo.id, this.sponserData).subscribe(
        data => {

          this.router.navigate(['/viewsponsor', this.sponserIdToUpdate]);
          this.messageService.add({
            key: 'tc',
            severity: 'success',
            summary: 'Sponsor Information has been saved',
            detail: '',
          });
          this.localConatctId = 0;
          this.compareModels();
        }

      );
    }
    else {
      this.messageService.add({ key: 'tc', severity: 'warn', summary: 'Please enter required information', detail: '' });
    }
  }

  openContactModel() {
    this.uniqueSponsorContactNameMessage = false;
    this.currentSponsorContactIndex = -1;
    this.dialogFormGroup.reset();
    Object.keys(this.dialogFormGroup.controls).forEach(key => {
      this.dialogFormGroup?.get(key)?.setErrors(null);

    });
    this.contactSubmitted = false;
    this.sponserContact.id = 0;
    this.sponserContact.name = "";
    this.sponserContact.designation = "";
    this.sponserContact.countryCode = "";
    this.sponserContact.phoneNumber = "";
    this.sponserContact.email = "";
    this.displayDialog = true;
    this.contactHeader = 'Add Contact';
    this.iscontactExist = false;

  }
  isSavePopupBtnDisable = false;
  SaveContact() {
    this.isSavePopupBtnDisable = true;
    setTimeout(() => {
      this.isSavePopupBtnDisable = false;
    }, 3000);
    this.contactSubmitted = true;
    this.trimInput();
    if (this.dialogFormGroup.valid && !this.uniqueSponsorContactNameMessage) {
      this.contactSubmitted = false;
      this.sponserContact.createdBy = this.privilegeService.getLoginUserId();
      this.sponserContact.createdDate = new Date();
      this.sponserContact.updatedBy = this.privilegeService.getLoginUserId();
      this.sponserContact.updatedDate = new Date();
      this.sponserContact.isDeleted = false;
      if (this.sponserContact.id == undefined) {
        this.sponserContact.id = 0;
      }

      if (!this.editContactFlag) {
        this.sponserContact.localId = this.localConatctId;
        this.editContactFlag = false;
      }

      const index = this.sponserContactList.findIndex(model => model.localId === this.sponserContact.localId);
      if (index !== -1) {
        this.sponserContactList[index] = this.sponserContact;

      }
      else {
        this.sponserContactList.push(this.sponserContact);
      }


      this.sponserContact = {};
      this.localConatctId = this.localConatctId + 1;
      this.displayDialog = false;
      this.messageService.add({
        key: 'tc',
        severity: 'success',
        summary: 'Contact Information has been saved',
        detail: '',
      });

    }
    this.editContactFlag = false;
  }

  trimInput() {
    const control = this.dialogFormGroup.get('contactName');
    if (control && control.value) {
      control.setValue(control.value.trim());
    }
  }
  editContact(cardData: any, rowIndex: any) {

    this.uniqueSponsorContactNameMessage = false;
    this.sponserContact.name = cardData?.name;
    this.sponserContact.designation = cardData?.designation;
    this.sponserContact.countryCode = cardData?.countryCode;
    this.sponserContact.phoneNumber = cardData?.phoneNumber;
    this.sponserContact.email = cardData?.email;
    this.sponserContact.id = cardData?.id;
    this.sponserContact.localId = cardData?.localId;
    this.editContactFlag = true;
    this.displayDialog = true;
    this.contactHeader = 'Edit Contact';
    this.currentSponsorContactIndex = rowIndex;
  }



  _supplierMSADetails: SuppliersMasterServiceAgreement[] = [];
  supplierdata: any;

  ContactIndex: any;
  selectedItem: any

  engagementDataSource: any;
  getAllEngagementsBySponsorId() {
    this.engagementService.getAllEngagementsBySponsorId(this.sponserIdToUpdate).subscribe(
      (res: any) => {
        this.engagementDataSource = res.data;
      });
  }







  isContactExistOnMSA = false;
  isContactExistOnContract = false;

  confirm(item: any) {
    this.loaderService.showLoader();
    this.selectedItem = item;


    var msaIndex;
    if (this.sponserIdToUpdate != 0) {
      msaIndex = this.engagementDataSource.findIndex((engagement: any) => {
        return engagement.engagementMasterServiceAgreements.some((msa: any) => {
          return msa.sponsorContactId === item.id;
        });
      });
    }
    else {
      msaIndex = -1;
    }


    if (msaIndex == -1) {
      this.isContactExistOnMSA = false;
    }
    else {
      this.selectedItem = null;
      this.isContactExistOnMSA = true;
    }

    this.CheckContactOnEngagementsContracts(item.id);
  }


  engagementContractList: any;
  CheckContactOnEngagementsContracts(contactId: any) {
    this._contractService.GetAllEngagementsContractsBySponsorId(this.sponserIdToUpdate).subscribe
      (res => {
        this.engagementContractList = res.data;


        let activeTitles: string[] = [];
        this.engagementContractList.forEach((contract: any) => {

          var isExist = this.engagementContractList.filter((aa: any) => aa.sponserContactId == contactId);
          if (isExist.length > 0) {
            activeTitles.push(contract.title);
          }

        });

        let commaSeparatedTitles = "";
        if (activeTitles.length > 0) {
          commaSeparatedTitles = activeTitles.join(', ');
          this.isContactExistOnContract = true;
        }
        else {
          this.isContactExistOnContract = false;
        }



        if (this.isContactExistOnMSA == true && this.isContactExistOnContract == true) {
          this.messageService.add({ key: 'tc', severity: 'warn', life: 8000, summary: 'This contact is selected as the Owner on the Contract(s) "' + commaSeparatedTitles + '" and also on an MSA. It cannot be deleted', detail: '' })
          this.loaderService.hideLoader();
        }
        else if (this.isContactExistOnMSA == true && this.isContactExistOnContract == false) {
          this.messageService.add({ key: 'tc', severity: 'warn', life: 8000, summary: 'This contact is linked to an MSA and cannot be deleted.', detail: '' })
          this.loaderService.hideLoader();
        }
        else if (this.isContactExistOnMSA == false && this.isContactExistOnContract == true) {
          this.messageService.add({ key: 'tc', severity: 'warn', life: 8000, summary: 'This contact is selected as the Owner on the Contract(s) "' + commaSeparatedTitles + '" and cannot be deleted', detail: '' })
          this.loaderService.hideLoader();
        }
        else {
          this.loaderService.hideLoader();
          this.confirmationService.confirm({
            message: 'Are you sure you want to delete this contact from this Sponsor?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
              this.deleteItem();
              this.messageService.add({
                key: 'tc',
                severity: 'success',
                summary: 'Contact has been deleted',
                detail: '',
              });
            },
            reject: (type: any) => {

            }
          });
        }
      });
  }


  deleteContact(cardData: any) {
    this.ContactIndex = this.sponserContactList.findIndex(contact => contact.localId === cardData.localId);
    if (this.ContactIndex != -1) {
      this.selectedItem = cardData;
      this.confirmationService.confirm({
        message: 'Are you sure you want to delete this contact?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.deleteItem();
          this.messageService.add({
            key: 'tc',
            severity: 'success',
            summary: 'Contact has been deleted',
            detail: '',
          });
        },
        reject: (type: any) => {
          this.selectedItem = null;
        }
      });
    }


  }
  deleteItem() {
    const contactIndex = this.sponserContactList.findIndex(item => item === this.selectedItem);
    if (contactIndex !== -1) {
      this.sponserContactList.splice(contactIndex, 1);
      this.selectedItem = null;
    }
  }

  closeDialog() {
    this.displayDialog = false;
    this.selectedItem = null;
    this.editContactFlag = false;
    this.messageService.add({
      key: 'tc',
      severity: 'info',
      summary: 'Contact Information has not been saved',
      detail: '',
    });

  }

  BackToListPage() {
    this.router.navigate(['/viewsponsor', this.sponserIdToUpdate]);

  }
  ediSponcheckSponsorContactNameExist(contactDetails: any) {
    if (this.sponserContactList.length > 0) {
      if (this.isNameRepeated(contactDetails)) {
        this.uniqueSponsorContactNameMessage = true;
      } else {
        this.uniqueSponsorContactNameMessage = false;
      }
    }

  }
  currentSponsorContactIndex = -1;
  isNameRepeated(contactDetails: any): boolean {

    this.uniqueSponsorContactNameMessage = false;
    let nameCount = 0;
    const contactName = contactDetails.name.toLowerCase();
    if (this.currentSponsorContactIndex == -1) {
      this.sponserContactList.forEach((obj: any, index: any) => {
        if (obj.name.toLowerCase() === contactName) {
          nameCount++;
        }
      });
    }
    else if (this.currentSponsorContactIndex >= 0) {
      this.sponserContactList.forEach((obj: any, index: any) => {
        if (obj.name.toLowerCase() === contactName && index != this.currentSponsorContactIndex) {
          nameCount++;
        }
      });
    }

    return nameCount > 0;
  }
  canExist(): boolean | Promise<boolean> | Observable<boolean> {
    if (this.executeCanExist && !(this.oldSponserData == JSON.stringify(this.sponserInfo) && (this.oldSponserContactData == JSON.stringify(this.sponserContactList)))) {
      return new Promise<boolean>((resolve) => {
        this.confirmationService.confirm({
          message: 'Changes will not be saved,  Do you want to continue?',
          header: 'Confirmation',
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
            this.messageService.add({
              key: 'tc',
              severity: 'info',
              summary: 'Changes not saved',
              detail: '',
            });
            resolve(true);
          },
          reject: () => {
            resolve(false);
          },
        });
      });
    }
    else {
      return true;
    }
  }
  generateBreadcrumb(component?: string, recordName?: string) {
    this.breadcrumbService.generateBreadcrumb(component, recordName);
  }
  getBreadcrumbs(): MenuItem[] {
    return this.breadcrumbService.getBreadcrumbs();
  }

  onOptionChange(event: any): void {
    this.filterselectedsponserstatus = this.statusData;
    this.selectedsponserstatus = this.filterselectedsponserstatus.filter((x: any) => (x.id == event.value));
    try {
      if ((this.selectedsponserstatus[0].name == ActiveInActiveStatus.Active) && this.sponserInfo.sponserId != null && this.sponserInfo.sponserId != undefined) { //Sponser and all the suppliers are made inactive linked under this sponserid
        this.statusInactive = false;
      }
      else {
        if (!(this.selectedsponserstatus[0].name == ActiveInActiveStatus.Active) && this.sponserInfo.sponserId != null && this.sponserInfo.sponserId != undefined) { //Sponser and all the suppliers are made inactive linked under this sponserid
          this._SupplierSerice.GetSuppliersLinkedwithSponserId(this.sponserInfo.id)
            .subscribe(res => {
              this.noOfSuppliersAreLinkedwithSponserId = res.data;
              this.confirmationService.confirm({
                header: 'Confirm Inactivate Sponsor',
                message: 'The Sponsor has ' + res.data.length + ' Supplier(s) linked under it, do you still want to make it inactive? This will result in making any Suppliers and contracts under it being made inactive as well.',
                accept: () => {
                  this.statusInactive = true;
                },
                reject: () => {
                  this.statusInactive = false;
                  this.defaultactivestatus = this.statusData;
                  this.defaultselectedactivestatus = this.defaultactivestatus.filter((x: any) => x.name == ActiveInActiveStatus.Active)
                },
              });
            });
        }
      }

    }
    catch (error) {
      console.log(error);
    }
  }
  InActivateSponser(sponserId: any, StatusMappingId: any, status: any) //Inactivate sponser
  {

    if (status)
      this.statusValue = "inactive";
    else
      this.statusValue = "active";
    try {
      this._service.InActivateSponserById(sponserId, StatusMappingId, status)
        .subscribe(res => {
          if (res.data > 0) {
            this.messageService.add({
              key: 'tc',
              severity: 'success',
              summary: 'Sponsor and underlying suppliers and contracts have been made' + '  ' + this.statusValue + '.',
              detail: '',
            });

          }
        });
    }
    catch (error) {
      console.log(error);
    }
  }


  orginalStatusData: any;
  GetsponserStatus() {
    this._service.getCodeListData(3, 'Sponser').subscribe(
      data => {
        this.statusData = data.data;
        this.orginalStatusData = data.data
        this.getSponserData();
      });

  }
  GetSupplierStatus() {
    this._service.getCodeListData(3, 'Supplier').subscribe(
      data => {
        this.supplierStatusData = data.data;
      }
    );
  }
  GetContractStatus() {
    this._service.getCodeListData(3, 'Contract').subscribe(
      data => {
        this.contractStatusData = data.data;

      }
    );
  }

  contactUniqueMessage: string = "";
  iscontactExist = false;
  IsCheckDuplicateContact(name: any): void {
    this.contactUniqueMessage = "Contact Name already exists in this Sponsor. Please enter a unique Name";
    this.iscontactExist = this.sponserContactList.some(obj => obj.name?.toLowerCase() === name.toLowerCase())

  }

  //Audit payload
  changedSponsorBasicInfo: any;
  changedSponsorContactInfo: any;
  listChangedSponsorBasicContactInfo: any;
  auditModelForSponser = new AuditLogModel();
  auditModelForSponserContact = new AuditLogModel();
  compareModels() {

    //Getting Changes Properties Array
    this.changedSponsorBasicInfo = this.auditLogService.compareModels(JSON.parse(this.sponsorDetailBeforeUpdate), this.sponserInfo, this.auditEntities.SponsorDetails, this.auditIdentifierDetails.SponsorDetails, this.auditOperations.Update, this.auditModule.Sponsorservice);


    this.sponsorContactDetailListBeforeUpdate = JSON.parse(this.sponsorContactDetailListBeforeUpdate);
    this.sponserContactList.forEach((item: any) => {

      if (item.id != 0 && !(item.isDeleted))//Edit case
      {
        var oldContactInfo = this.sponsorContactDetailListBeforeUpdate.filter((aa: any) => aa.id == item.id);
        this.changedSponsorContactInfo = this.auditLogService.compareModels(oldContactInfo[0], item, this.auditEntities.SponsorContacts, this.auditIdentifierDetails.SponsorContacts, this.auditOperations.Update, this.auditModule.Sponsorservice);
      }
      else if (item.id != 0 && item.isDeleted)//DeleteContact Case
      {
        this.changedSponsorContactInfo = this.auditLogService.compareModels(item, this.blankSponsorContact, this.auditEntities.SponsorContacts, this.auditIdentifierDetails.SponsorContacts, this.auditOperations.Delete, this.auditModule.Sponsorservice);
      }
      else//new contact
      {
        this.changedSponsorContactInfo = this.auditLogService.compareModels(this.blankSponsorContact, item, this.auditEntities.SponsorContacts, this.auditIdentifierDetails.SponsorContacts, this.auditOperations.Create, this.auditModule.Sponsorservice);
      }
    });
    if (this.sponserContactList.length !== this.sponsorContactDetailListBeforeUpdate.length) {
      const deletedContacts = this.sponsorContactDetailListBeforeUpdate.filter((oldContact: { id: number; }) =>
        !this.sponserContactList.some(newContact => newContact.id === oldContact.id)
      );

      if (deletedContacts.length > 0) {

        this.changedSponsorContactInfo = this.auditLogService.compareModels(
          deletedContacts, [], this.auditEntities.SponsorContacts, this.auditIdentifierDetails.SponsorContacts, this.auditOperations.Update, this.auditModule.Sponsorservice
        );
      }
    }

    //Sponsor Products
    const productsBeforeUpdate = JSON.parse(this.productListBeforeUpdate || '[]');
    (this.newProducts || []).forEach((item: any) => {
      if (item.id)//Edit case
      {
        var oldProductInfo = productsBeforeUpdate.find((aa: any) => aa.id == item.id);
        this.auditLogService.compareModels(this.getProductAuditModel(oldProductInfo), this.getProductAuditModel(item), this.auditEntities.SponsorProducts, this.auditIdentifierDetails.SponsorProducts, this.auditOperations.Update, this.auditModule.Sponsorservice,
          {
            'Sponsor': this.sponserInfo.name,
            'Product': item.productName
          });
      }
      else//new product
      {
        this.auditLogService.compareModels({}, this.getProductAuditModel(item), this.auditEntities.SponsorProducts, this.auditIdentifierDetails.SponsorProducts, this.auditOperations.Create, this.auditModule.Sponsorservice,
          { 'Sponsor': this.sponserInfo.name });
      }
    });

  }

  productListBeforeUpdate: any; // Used for audit logging
  getProductAuditModel(product: any) {
    return {
      productName: product?.productName ?? null,
      longName: product?.longName ?? null,
      genericName: product?.genericName ?? null,
      internalName: product?.internalName ?? null,
      tradeName: product?.tradeName ?? null,
      lifecycleState: this.statusData?.find((status: any) => status.id == product?.statusMappingId)?.name ?? null
    };
  }

  GetAllSponsors() {
    this._service.GetAllSponsers().subscribe(
      (res: { data: any[]; }) => {
        this.allSponsordetails = res.data;
      }
    );
  };
  checkSponsorNameExist() {
    this.uniqueSponsorNameMessage = false;
    const contactIndex = this.allSponsordetails.findIndex(item => item.name.toLowerCase() === (this.sponserInfo.name?.toLocaleLowerCase()));
    if (contactIndex !== -1 && this.sponserIdToUpdate !== this.allSponsordetails[contactIndex].id) {
      this.uniqueSponsorNameMessage = true;
    }
    else {
      this.uniqueSponsorNameMessage = false;
    }
  }

  onAddProduct() {
    this.productSubmitted = false;
    this.uniqueProductNameMessage = false;
    this.products.productName = '';
    this.products.longName = '';
    this.products.genericName = '';
    this.products.internalName = '';
    this.products.tradeName = '';
    this.displayAddProductDialog = true;
     }
  BindPrivileges() {
    const hasPermission = (privilege: Privileges) => this.privilegeService.hasPermission(privilege);
    this.editPrivilege = hasPermission(Privileges.EditSponsor);
    this.ExportPrivilege = hasPermission(Privileges.ExportlistofSponsors);
  }


  selectedProducts: any;
  isChecked: boolean = true;
  CheckboxEnabled() {
    if (this.selectedProducts.length > 0) {
      this.isChecked = false;
    }
    else {
      this.isChecked = true;
    }
  }
  selectedRecordsToExpotToExcel: any[] = [];
  productSubmitted = false;
  uniqueProductNameMessage = false;
  displayAddProductDialog: boolean = false;
  ExportProductData() {

    this.selectedRecordsToExpotToExcel = this.selectedProducts;
    const dataToExport = this.selectedRecordsToExpotToExcel.map((product) => {
      return {
        'Product Name': product.productName,
        'Long Name': product.longName,
        'Generic Name': product.genericName,
        'Internal Name': product.internalName,
        'Trade Name': product.tradeName,
        'Lifecycle State': this.statusData.find((status: any) => status.id == product.statusMappingId).name,
        'Modified By': product.updatedBy,
        'Modified Date and Time':product.updatedDate!=null?this.convertDateTimeFormat(product.updatedDate):product.updatedDate,
      };
    });
    this.exportExcel(dataToExport);

  }

  exportExcel(SelectedRecords: any) {
    import('xlsx').then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(SelectedRecords);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, "Products");
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    this.auditLogService.logExport('Sponsor Products',this.auditIdentifierDetails.SponsorDetails,this.auditModule.Sponsorservice,fileName);

    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = FileExtension.ExportExtention;
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName);
  }

  displayProductDialog: boolean = false;
  originalProductData: any;
  selectedProduct = new SponsorProduct();
  updatedByName:any;
  onEditProduct(product: any) {
    this.selectedProduct = { ...product };
    this.originalProductData = { ...product };
    this.displayProductDialog = true;
     if (this.selectedProduct.updatedBy) {
  this.updatedByName = product.updatedBy;
}
  }

convertDateTimeFormat(inputDateTime: any) {
  const date = new Date(inputDateTime);

  const day = date.getUTCDate().toString().padStart(2, '0');
  const month = new Intl.DateTimeFormat('en-US', { month: 'short', timeZone: 'UTC' }).format(date);
  const year = date.getUTCFullYear();

  const hours = date.getUTCHours().toString().padStart(2, '0');
  const minutes = date.getUTCMinutes().toString().padStart(2, '0');

  return `${day}-${month}-${year} ${hours}:${minutes} UTC`;
}

onUpdateProduct() {

  const statusMap = new Map<number, string>();
  this.statusData.forEach((status: { id: number; name: string }) => {
    statusMap.set(status.id, status.name);
  });

  const matchProduct = (p: any, selected: any) => {

    if (p.localId != null && selected.localId != null) {
      return p.localId === selected.localId;
    }

    if (p.id != null && selected.id != null) {
      return p.id === selected.id;
    }

    return false;
  };

  this.selectedProduct = {
    ...this.selectedProduct,
    statusMappingId: this.selectedProduct.statusMappingId,
    status: statusMap.get(Number(this.selectedProduct.statusMappingId)),
    updatedBy: this.privilegeService.getUserName(this.privilegeService.getLoginUserId()),
    updatedDate: new Date(
            new Date().toISOString()
        ),
  };


  const updateList = (list: any[]) => {
    return list.map(product => {
      if (matchProduct(product, this.selectedProduct)) {
        return {
          ...product,
          statusMappingId: this.selectedProduct.statusMappingId,
          status: this.selectedProduct.status,
          updatedBy: this.selectedProduct.updatedBy,
          updatedDate: this.selectedProduct.updatedDate,
        };
      }
      return product;
    });
  };

  this.productList = [...updateList(this.productList)];
  this.allProducts = updateList(this.allProducts);

  const existsInNewProducts = this.newProducts.some(p =>
    matchProduct(p, this.selectedProduct)
  );

  if (existsInNewProducts) {

    this.newProducts = updateList(this.newProducts);

  } else {

    const fullProduct = this.productList.find(p =>
      matchProduct(p, this.selectedProduct)
    );

    if (fullProduct) {
      this.newProducts = [
        ...this.newProducts,
        { ...fullProduct }
      ];
    }
  }

  this.messageService.add({
    key: 'tc',
    severity: 'success',
    summary: 'Product Information has been saved',
    detail: '',
  });

  this.displayProductDialog = false;

  this.productFormGroup.reset();

  Object.keys(this.productFormGroup.controls).forEach(key => {
    const control = this.productFormGroup.get(key);
    control?.setErrors(null);
    control?.markAsPristine();
    control?.markAsUntouched();
  });
  this.updatedByName = null
  this.selectedProducts =[]

}
  onCancelEditProduct() {
    const currentData = JSON.stringify(this.selectedProduct);
    const originalData = JSON.stringify(this.originalProductData);
    const isChanged = currentData !== originalData;

    if (isChanged) {
      this.confirmationService.confirm({
        message: 'If you cancel, the entered Product Details will be lost and not saved. Do you want to continue?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Yes',
        rejectLabel: 'No',

        accept: () => {

          this.displayProductDialog = false;
          this.selectedProduct = { ...this.originalProductData };
          this.messageService.add({
            key: 'tc',
            severity: 'info',
            summary: 'Product Information has not been saved',
            detail: '',
          });
          this.productFormGroup.reset();

          Object.keys(this.productFormGroup.controls).forEach(key => {
          this.productFormGroup.get(key)?.setErrors(null);
          this.productFormGroup.get(key)?.markAsPristine();
          this.productFormGroup.get(key)?.markAsUntouched();
        });
        },

        reject: () => {
        }
      });

    } else {
      this.displayProductDialog = false;
       this.messageService.add({
            key: 'tc',
            severity: 'info',
            summary: 'Product Information has not been saved',
            detail: '',
          });
        this.productFormGroup.reset();

        Object.keys(this.productFormGroup.controls).forEach(key => {
          this.productFormGroup.get(key)?.setErrors(null);
          this.productFormGroup.get(key)?.markAsPristine();
          this.productFormGroup.get(key)?.markAsUntouched();
        });
    }
    this.updatedByName = null;
  }

  productFilterDetailsModel = new ProductFilterDetails();

  ClearFilters() {
    this.productFilterDetailsModel = {
      ProductName: '',
      longName: '',
      genericName: '',
      internalName: '',
      tradeName: ''
    }
  this.productList = [...this.allProducts];
  this.filteredRecordCount = this.productList.length;

  }
  allProducts: any[] = [];

   onfilter(event: any) {
    this.productList = [...this.allProducts];

      const productSearch = this.productFilterDetailsModel.ProductName?.toLowerCase();

      if (!productSearch) {
      this.productList = [...this.allProducts];
      } 
    else {
      this.productList = this.productList.filter(a =>
      a.productName?.toLowerCase().includes(productSearch) ||
      a.longName?.toLowerCase().includes(productSearch) ||
      a.genericName?.toLowerCase().includes(productSearch) ||
      a.internalName?.toLowerCase().includes(productSearch) ||
      a.tradeName?.toLowerCase().includes(productSearch)
    );
    }
    this.filteredRecordCount = this.productList.length;
      this.table.first = 0;
  }

  getSponserData() {

    this._service.getSponserData(this.sponserIdToUpdate).subscribe(
      res => {
        this.loaderService.hideLoader();
        this.selectedProducts = [];
        this.isChecked = true;
        this.sponserInfo.name = res.data.sponserInfo?.name;

        this.sponserInfo.address = res.data.sponserInfo?.address;
        this.sponserInfo.notesAndComments = res.data.sponserInfo?.notesAndComments;
        this.sponserInfo.id = res.data.sponserInfo?.id;
        this.sponserInfo.sponserId = res.data.sponserInfo?.sponserId;

        this.auditLogService.logViewWithFilters('Edit Sponsor',this.sponserInfo.sponserId || this.auditIdentifierDetails.SponsorDetails,this.auditModule.Sponsorservice,{
          'Sponsor': this.sponserInfo.name
        });

        this.CreatedbyUserName = this.privilegeService.getUserName(res.data.sponserInfo?.createdBy);
        this.sponserInfo.createdDate = res.data.sponserInfo?.createdDate;

        this.allProducts = (res.data.products || []).map((p: { updatedDate: string; createdDate: string; }) => ({
          ...p,
          updatedDate: p.updatedDate ? new Date(p.updatedDate + 'Z') : null,
          createdDate: p.createdDate ? new Date(p.createdDate + 'Z') : null
        }));
        this.productList = [...this.allProducts];

        const statusMap = new Map<number, string>();
        this.statusData.forEach((status: { id: number; name: string; }) => {
          statusMap.set(status.id, status.name);
        });

        this.productList.forEach((product: any) => {
          const statusId = Number(product.statusMappingId);
          product.status = statusMap.get(statusId) || 'Unknown';
          product.createdBy = this.privilegeService.getUserName(product.createdBy);
          product.updatedBy = this.privilegeService.getUserName(product.updatedBy);
        });

        this.totalRecordCount = this.productList.length;
        this.filteredRecordCount = this.productList.length;

        this.sponserContactList = res.data.sponserContacts || [];
        this.generateBreadcrumb(this._enumBreadcrumb.EVSP, this.sponserInfo.name);



        this.oldSponserData = JSON.stringify(this.sponserInfo);


        this.sponsorDetailBeforeUpdate = JSON.stringify(this.sponserInfo);
        this.sponsorContactDetailListBeforeUpdate = JSON.stringify(this.sponserContactList);
        this.productListBeforeUpdate = JSON.stringify(res.data.products || []);

        // this.GetsponserStatus();
        this.sponserContactList.forEach(item => {
          const exists = this.updatedSponserContactList.some(
            existing => existing.id === item.id && item.id !== 0
          );

          if (!exists) {
            item.localId = this.localConatctId;
            this.localConatctId = this.localConatctId + 1;
            this.updatedSponserContactList.push(item);
          }

        });

        this.sponserContactList = this.updatedSponserContactList;
        this.oldSponserContactData = JSON.stringify(this.sponserContactList);

      });
  }
 
  saveProduct() {
    this.productSubmitted = true;
    this.productFormGroup.markAllAsTouched();


    if (this.productFormGroup.invalid || this.uniqueProductNameMessage) {
      this.messageService.add({
        key: 'tc',
        severity: 'warn',
        summary: 'Please enter required information',
        detail: ''
      });
      return;
    }

    this.executeCanExist = false;
    const objProductData: any = {
          localId: this.localProductId, 
          productName: this.products.productName,
          longName: this.products.longName,
          genericName: this.products.genericName,
          internalName: this.products.internalName,
          tradeName: this.products.tradeName,

          statusMappingId: this.products.statusMappingId,

          createdBy: this.privilegeService.getLoginUserId(),
          createdDate: new Date().toISOString(),

          isDeleted: false,
          updatedBy: null,
          updatedDate: null
        };

        const statusMap = new Map<number, string>();
        this.statusData.forEach((status: { id: number; name: string }) => {
          statusMap.set(status.id, status.name);
        });


        const statusId = Number(objProductData.statusMappingId);
        objProductData.status = statusMap.get(statusId) || 'Unknown';

        this.productList = [...this.productList, { ...objProductData }];
        this.allProducts = [...this.allProducts, { ...objProductData }];
        this.newProducts = [...this.newProducts, { ...objProductData }];

      this.localProductId = this.localProductId + 1;
      this.totalRecordCount = this.productList.length;

        if (this.filteredRecordCount > -1) {
          this.filteredRecordCount = this.productList.length;
        }

        this.messageService.add({
          key: 'tc',
          severity: 'success',
          summary: 'Product Information has been saved',
          detail: ''
        });
        this.displayAddProductDialog = false;
        this.productFormGroup.reset();

        Object.keys(this.productFormGroup.controls).forEach(key => {
          this.productFormGroup.get(key)?.setErrors(null);
          this.productFormGroup.get(key)?.markAsPristine();
          this.productFormGroup.get(key)?.markAsUntouched();
        });
      


  }
  onCancelProduct() {
    const formValues = this.productFormGroup.value;

    const isChanged = Object.values(formValues).some(value =>
      value !== null && value !== undefined && value !== ''
    );

    if (isChanged) {

      this.confirmationService.confirm({
        message: 'If you cancel, the entered Product Details will be lost and not saved. Do you want to continue?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Yes',
        rejectLabel: 'No',

        accept: () => {
          this.displayAddProductDialog = false;

          this.productFormGroup.reset();
          this.newProducts = []

          Object.keys(this.productFormGroup.controls).forEach(key => {
            this.productFormGroup.get(key)?.setErrors(null);
            this.productFormGroup.get(key)?.markAsPristine();
            this.productFormGroup.get(key)?.markAsUntouched();
          });

          this.messageService.add({
            key: 'tc',
            severity: 'info',
            summary: 'Product Information has not been saved',
            detail: '',
          });
        },

        reject: () => {
        }
      });

    } else {
          this.displayAddProductDialog = false;

          this.productFormGroup.reset();

          Object.keys(this.productFormGroup.controls).forEach(key => {
            this.productFormGroup.get(key)?.setErrors(null);
            this.productFormGroup.get(key)?.markAsPristine();
            this.productFormGroup.get(key)?.markAsUntouched();
          });

          this.messageService.add({
            key: 'tc',
            severity: 'info',
            summary: 'Product Information has not been saved',
            detail: '',
          });
    }

  }
  checkProductNameExist(productDetails: any) {
    if (this.productList.length > 0) {
      if (this.isNameRepeated(productDetails)) {
        this.uniqueProductNameMessage = true;
      } else {
        this.uniqueProductNameMessage = false;
      }
    }
  }

  currentProductIndex = -1;
  // isNameRepeated(productDetails: any): boolean {
  //   this.uniqueProductNameMessage=false;
  //       let nameCount = 0;
  //       const productName = productDetails.name.toLowerCase();
  //       if(this.currentProductIndex==-1) 
  //       {
  //         this.productList.forEach((obj: any, index: any) => {
  //           if (obj.name.toLowerCase() === productName) {
  //               nameCount++;
  //           }
  //       });
  //       }
  //       else if(this.currentProductIndex>=0){
  //         this.productList.forEach((obj: any, index: any) => {
  //           if (obj.name.toLowerCase() === productName &&  index!=this.currentProductIndex) {
  //               nameCount++;
  //           }
  //       });
  //       }

  //       return nameCount > 0;
  //   }

}
